import { useRef } from 'react';
import PropTypes from 'prop-types';
import { useTabListState } from 'react-stately';
import { useTabList } from 'react-aria';

import Tab from '../Tab/Tab';
import TabPanel from '../TabPanel/TabPanel';

import defaultAriaProps from 'client/utils/constants/ariaPropTypes';

import styles from './Tabs.module.scss';

const Tabs = props => {
    const state = useTabListState(props);
    const ref = useRef();
    const { tabListProps } = useTabList(props, state, ref);
    const hideIconBar = state.collection.size <= 1;

    return (
        <div
            data-testid={props['data-testid'] ? props['data-testid'] : null}
            className={[
                styles.tabs
            ].join(' ')}
        >
            <div
                {...tabListProps}
                ref={ref}
                className={[
                    styles.list,
                    hideIconBar ? styles.hidden : null
                ].join(' ')}
            >
                {[...state.collection].map((item) => (
                    <Tab
                        key={item.key}
                        item={item}
                        state={state}
                        orientation={props.orientation}
                    />
                ))}
            </div>
            <TabPanel
                key={state.selectedItem?.key}
                state={state}
                orientation="vertical"
            />
        </div>
    );
};

Tabs.propTypes = {
    ...defaultAriaProps,
    orientation: PropTypes.oneOf(['vertical'])
};

export default Tabs;
